import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ScrudgService } from '../base/scrudg/scrudg.service';
import { Observable } from 'rxjs';
import { ProductionStatus } from '../../models/data/talent-core/production-status';
import { HttpFactory } from '../../utilities/http-factory';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { ProductionRole } from '../../models/data/talent-core/production-role';

@Injectable({
    providedIn: 'root'
})

export class ProductionService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "production");
    }

    public getProductionStatuses(): Observable<ProductionStatus[] | null> {

        const result = HttpFactory.get<ProductionStatus[]>(this.http, this._controllerName + "/productionstatuses", this._apiBaseUrl);

        return result;
    }

    public getProductionRolesByIds(ids: number[]): Observable<ProductionRole[] | null> {

        const result = HttpFactory.post<ProductionRole[]>(this.http, ids, this._controllerName + "/productionrolesbyids", this._apiBaseUrl);

        return result;
    }
}
